import qs from 'qs'

import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingPerson, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingPeopleDetailsRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/People${queryString}`,
  }
}

const useTrainingPeopleDetailsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingPerson[] | undefined
>({
  getRequest: getTrainingPeopleDetailsRequest,
  getQueryKey: (params, queryObject) => [
    'training-people-details',
    queryObject?.activeOnly,
  ],
})

const useTrainingPeopleDetailsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingPerson[] | undefined, Error>,
) => {
  const trainingPeopleQuery = useTrainingPeopleDetailsQueryBase(undefined, queryObject, options)

  return { ...trainingPeopleQuery }
}
export default useTrainingPeopleDetailsQuery
